import { SearchInput } from "@circleco/compass/components/SearchInput";
import { useState } from "react";

export const NEWSLETTER_SEARCH_MAX_LENGTH = 255;
const NEWSLETTER_SEARCH_DEBOUNCE_MS = 500;

interface NewsletterSearchInputProps {
  dataTestId: string;
  name: string;
  onSearch: (value: string) => void;
  placeholder: string;
  query: string | undefined;
}

export const NewsletterSearchInput = ({
  dataTestId,
  name,
  onSearch,
  placeholder,
  query,
}: NewsletterSearchInputProps) => {
  const [searchValue, setSearchValue] = useState(query ?? "");
  const [syncedQuery, setSyncedQuery] = useState(query);
  const [lastSearched, setLastSearched] = useState(query ?? "");

  // Only adopt URL changes this input did not cause (back/forward, links),
  // so keystrokes typed while our own navigation settles are not clobbered.
  if (query !== syncedQuery) {
    setSyncedQuery(query);
    if ((query ?? "") !== lastSearched) {
      setLastSearched(query ?? "");
      setSearchValue(query ?? "");
    }
  }

  const handleSearch = (value: string) => {
    setLastSearched(value.trim());
    onSearch(value);
  };

  return (
    <div className="relative m-0.5 w-56">
      <SearchInput
        name={name}
        value={searchValue}
        onChange={event => {
          setSearchValue(event.target.value);
        }}
        onClear={() => {
          setSearchValue("");
        }}
        onSearch={handleSearch}
        placeholder={placeholder}
        aria-label={placeholder}
        maxLength={NEWSLETTER_SEARCH_MAX_LENGTH}
        debounceMs={NEWSLETTER_SEARCH_DEBOUNCE_MS}
        data-testid={dataTestId}
      />
    </div>
  );
};
